import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import Swal from "sweetalert2";

const SimulateBOM = () => {
    const userID = secureLocalStorage.getItem("userID");

    const {
        control,
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const [productData, setProductData] = useState([]);
    const [wips, setWips] = useState([]);
    const [rms, setRms] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { useCreate } = useAPIQuery({
        key: "checkBOM",
        endpoint: `/api/check-bom/`,
    });

    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const TypeMasterQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "BOM Constants",
            c: "category",
        },
    });

    const work_order_id = useMemo(() => {
        if (TypeMasterQueryData.data) {
            const typeMasterObject =
                TypeMasterQueryData.data?.results?.data?.find(
                    (tm) => tm?.name === "Work Order ID"
                );

            const id = typeMasterObject?.value;

            return id;
        }

        return null;
    }, [TypeMasterQueryData?.data]);

    const { data, isLoading, isFetching } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const handleSuccessCheckBOM = (data) => {
        const wipsAva = data?.data?.filter(
            (item) => item?.item?.category === "WIP"
        );
        const rmAva = data?.data?.filter(
            (item) => item?.item?.category === "Raw Material"
        );
        setWips(
            wipsAva.map((wip) => ({
                id: wip?.id,
                item_code: wip?.item?.item_code,
                item_id: wip?.item?.id,
                item_name: wip?.item?.item_name,
                category: wip?.item?.category,
                allotted_stock: wip?.allotted_stock,
                work_order_req_quantity: wip?.work_order_req_quantity,
                item_per_product: wip?.bom?.item_per_product,
                uom: wip?.item?.uom,
                available: wip?.item?.stock_quantity ?? 0,
                wo_id: wip?.work_order?.id,
            }))
        );
        setRms(
            rmAva.map((rm) => ({
                id: rm?.id,
                item_code: rm?.item?.item_code,
                item_id: rm?.item?.id,
                item_name: rm?.item?.item_name,
                category: rm?.item?.category,
                work_order_req_quantity: rm?.work_order_req_quantity,
                item_per_product: rm?.bom?.item_per_product,
                uom: rm?.item?.uom,
                stock_quantity: rm?.item?.stock_quantity,
            }))
        );
    };

    const { mutate: mutateCheckBOM, isPending: loadingCheckbom } = useCreate({
        params: {
            action: "simulate-bom",
        },
        errorMessageFromServer: true,
        successMessageFromServer: true,
        onSuccess: handleSuccessCheckBOM,
        retry: 2,
    });

    const columns = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "category",
            header: "Category",
        },
        {
            accessor: "item_per_product",
            header: "Item/Pro",
        },
        {
            accessor: "allotted_stock",
            header: "Allotted Stock",
        },
        {
            accessor: "work_order_req_quantity",
            header: "Work Order Require Quantity",
        },
        {
            accessor: "uom",
            header: "UOM",
        },
    ];

    const columnsRM = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "category",
            header: "Category",
        },
        {
            accessor: "item_per_product",
            header: "Item/Pro",
        },
        {
            accessor: "stock_quantity",
            header: "Stock Quantity",
        },
        {
            accessor: "work_order_req_quantity",
            header: "Work Order Require Quantity",
        },
        {
            accessor: "uom",
            header: "UOM",
        },
    ];

    const onSubmit = (data) => {
        console.log(data);

        if (!work_order_id) {
            Swal.fire({
                title: "Error",
                text: "Work order is not configured",
                icon: "error",
            });

            return;
        }

        mutateCheckBOM({
            data: {
                item_id: data?.item?.value,
                work_order_id: work_order_id,
                target_quantity: Number(data?.quantity),
                created_by: userID,
                updated_by: userID,
            },
        });
    };

    useEffect(() => {
        if (data) {
            setProductData(data.item.filter((api) => api.category === "FG"));
        }
    }, [data]);
    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Simulate BOM
                        </h3>
                    </div>
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <div className="row g-4">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <label className="form-label">
                            Item
                            <span className="fs-8 text-danger"> *</span>
                        </label>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="w-100 me-2">
                                <Controller
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={
                                                productData?.map((api) => {
                                                    return {
                                                        label: api.item_name,
                                                        value: api.id,
                                                        item_code:
                                                            api.item_code,
                                                        bom_code: api.bom_code,
                                                    };
                                                }) ?? []
                                            }
                                            isLoading={
                                                isLoading ||
                                                TypeMasterQueryData.isLoading ||
                                                isFetching
                                            }
                                            isDisabled={
                                                isLoading ||
                                                TypeMasterQueryData.isLoading ||
                                                isFetching
                                            }
                                            isClearable={true}
                                            id="select-forms-product_id"
                                        />
                                    )}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    name="item"
                                    control={control}
                                />
                            </div>
                        </div>
                        {errors.item && (
                            <span className="fs-8 text-danger">
                                Item is required
                            </span>
                        )}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <label className="form-label">
                            Quantity
                            <span className="fs-8 text-danger"> *</span>
                        </label>
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Enter required quantity"
                                id="email-forms-quantity"
                                {...register(`quantity`, {
                                    validate: {
                                        positive: (value) =>
                                            value > 0 ||
                                            "Only positive numbers are allowed",
                                    },
                                })}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>
                        {errors.quantity && (
                            <span className="fs-8 text-danger">
                                Quantity is required
                            </span>
                        )}
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12">
                        <button
                            className="btn btn-sm btn-primary mb-1"
                            disabled={
                                isLoading ||
                                TypeMasterQueryData.isLoading ||
                                isFetching ||
                                loadingCheckbom
                            }
                        >
                            {loadingCheckbom ? "Simulating..." : "Simulate"}
                        </button>
                    </div>
                </div>
            </form>

            {(wips?.length > 0 || rms?.length > 0) && (
                <div className="nk-block">
                    <div className="nk-block-head nk-block-head-sm mt-3">
                        <div className="nk-block-between">
                            <div className="nk-block-head-content d-flex">
                                <h6
                                    className="nk-block-title"
                                    style={{ fontSize: "1.3rem" }}
                                >
                                    WIP
                                </h6>
                            </div>
                        </div>
                    </div>
                    <Table
                        data={wips}
                        columns={columns}
                        isLoading={loadingCheckbom}
                        pagination={false}
                        selectRows={false}
                        globalSearch={false}
                        filterModal={false}
                        editRows={false}
                        deleteRows={false}
                    />
                    <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-between">
                            <div className="nk-block-head-content d-flex">
                                <h6
                                    className="nk-block-title"
                                    style={{ fontSize: "1.3rem" }}
                                >
                                    Raw Material
                                </h6>
                            </div>
                        </div>
                    </div>
                    <Table
                        data={rms}
                        columns={columnsRM}
                        isLoading={loadingCheckbom}
                        pagination={false}
                        selectRows={false}
                        globalSearch={false}
                        filterModal={false}
                        editRows={false}
                        deleteRows={false}
                    />
                </div>
            )}
        </>
    );
};

export default SimulateBOM;
